/* Carousel previews use the exact product/catalogue source crop and wood geometry. */
(() => {
  if (window.akCarouselPosterPreviewBound) return;
  window.akCarouselPosterPreviewBound = true;
  const aluDrawers = new WeakMap();
  const aluSizes = new ResizeObserver(entries => entries.forEach(({target}) => aluDrawers.get(target)?.()));
  function init() {
    const geometry = window.AK_POSTER_GEOMETRY;
    if (!geometry) return;
    document.querySelectorAll('[data-ak-carousel-poster]:not([data-ak-poster-ready])').forEach(stage => {
      const format = stage.dataset.format;
      const g = geometry.formats[format];
      if (!g) return;
      const aspect = Number(stage.style.getPropertyValue('--ak-card-aspect'));
      const fit = geometry.fitSource(100, 100 / aspect, Number(stage.dataset.sourceAspect), g.trim);
      const art = stage.querySelector('.ak-carousel-poster-art');
      let frame = stage.querySelector('.ak-carousel-poster-frame');
      if (!frame) { frame=document.createElement('img'); frame.className='ak-carousel-poster-frame'; frame.alt=''; stage.append(frame); }
      frame.hidden=false;
      // Incomplete or image-less search cards must not stop the remaining previews.
      if (!art) return;
      const isCart = stage.hasAttribute('data-ak-cart-preview');
      const saved=window.AK_PAPER_PREFS?.read();
      if(!isCart && saved && !stage.dataset.akCatalogSelected) {stage.dataset.akCatalogSelected='true';stage.dataset.akPreviewFrame=saved.frame;stage.dataset.akPreviewMount=saved.mount;}
      const selectedFrame = (isCart || stage.dataset.akCatalogSelected) ? stage.dataset.akPreviewFrame : 'black_wood';
      const requestedMount = (isCart || stage.dataset.akCatalogSelected) && selectedFrame !== 'none' ? stage.dataset.akPreviewMount : 'none';
      const selectedMount = requestedMount === 'creme' ? 'dark_creme' : requestedMount;
      const hasMount = selectedMount !== 'none';
      let mount = null;
      if (isCart || stage.dataset.akCatalogSelected) {
        const data = document.querySelector('[data-ak-catalog-config]');
        if (!data) return;
        const config = JSON.parse(data.textContent);
        const frameAsset = config.frame.find(entry => entry.value === selectedFrame)?.assets?.[format];
        if (frameAsset) frame.src = frameAsset;
        else frame.hidden = true;
        const mountAsset = config.mount.find(entry => entry.value === selectedMount)?.assets?.[format];
        if (mountAsset) {
          mount = document.createElement('img');
          mount.className = 'ak-carousel-poster-mount';
          mount.alt = '';
          mount.src = mountAsset;
          mount.width = mount.height = 1860;
          stage.append(mount);
        }
      }
      const offset = geometry.artOffset(format, selectedFrame, hasMount);
      const artStyle = {
        width: `${fit.sourceWidth}%`, height: `${fit.sourceHeight * aspect}%`,
        left: `calc(50% + ${fit.screenOffsetX}% + ${offset.x}px)`,
        top: `calc(50% + ${fit.screenOffsetY * aspect}% + ${offset.y}px)`,
        clipPath: `inset(${g.trim.map(v => `${v * 100}%`).join(' ')})`,
        transform: `var(--ak-carousel-poster-art-transform, translate(calc(-50% + .5px), -50%) scale(${geometry.artScale(format, selectedFrame, hasMount) * g.cropScale}))`
      };
      // Legacy search image rules use !important. Keep this shared geometry
      // authoritative there as well as in carousel cards.
      Object.entries(artStyle).forEach(([key, value]) => {
        const property = key.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
        art.style.setProperty(property, value, 'important');
      });
      [frame, mount].filter(Boolean).forEach(layer => {
        ['left','top','width','height'].forEach((key, i) => layer.style.setProperty(key, `${g.canvas[i]}%`, 'important'));
      });
      if (!isCart && !stage.dataset.akCatalogSelected && stage.closest('.ak-featured-carousel')) {
        const data = document.querySelector('[data-ak-catalog-config]');
        const hoverMountAsset = data && JSON.parse(data.textContent).mount.find(entry => entry.value === 'cashmere_grey')?.assets?.[format];
        if (hoverMountAsset) {
          const hoverMount = document.createElement('img');
          hoverMount.className = 'ak-carousel-poster-mount ak-carousel-poster-mount--hover';
          hoverMount.alt = '';
          hoverMount.width = hoverMount.height = 1860;
          hoverMount.loading = 'lazy';
          hoverMount.decoding = 'async';
          ['left','top','width','height'].forEach((key, i) => hoverMount.style.setProperty(key, `${g.canvas[i]}%`, 'important'));
          stage.style.setProperty('--ak-carousel-poster-mounted-transform',
            `translate(calc(-50% + .5px), -50%) scale(${geometry.artScale(format, selectedFrame, true) * g.cropScale})`);
          hoverMount.addEventListener('load', () => { stage.dataset.akPosterHoverReady = 'true'; }, {once:true});
          hoverMount.src = hoverMountAsset;
          stage.append(hoverMount);
        }
      }
      if (selectedFrame === 'black_alu') {
        const target = mount || art;
        const draw = () => window.akDrawAluFrame?.(stage, target, format, hasMount);
        target.addEventListener('load', draw, {once:true});
        aluDrawers.set(stage, draw);
        aluSizes.observe(stage);
        requestAnimationFrame(draw);
      }
      stage.dataset.akPosterReady = 'true';
    });
  }
  window.addEventListener('ak:paper-finish-change',event=>{
    if(!event.detail.selection)return;
    document.querySelectorAll('[data-ak-carousel-poster]:not([data-ak-cart-preview])').forEach(stage=>{
      stage.dispatchEvent(new CustomEvent('ak:catalog-poster-selection',{detail:event.detail.selection}));
    });
  });
  document.addEventListener('ak:catalog-poster-selection', event => {
    const stage=event.target;
    stage.dataset.akCatalogSelected='true';
    stage.removeAttribute('data-ak-poster-hover-ready');
    stage.dataset.akPreviewFrame=event.detail.frame;
    stage.dataset.akPreviewMount=event.detail.mount;
    stage.querySelectorAll('.ak-carousel-poster-mount,.ak-css-alu-frame').forEach(e=>e.remove());
    stage.removeAttribute('data-ak-poster-ready');
    init();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  new MutationObserver(init).observe(document.documentElement, {childList:true, subtree:true});
})();
